import { Icon, Intent, Spinner } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'

interface Props {
  currentRank?: number
  totalSteps: number
  running: boolean
}

const PROGRESS_DIVISOR = 0.85
const SPINNER_SIZE = 16

export const RunProgressIndicator: React.FC<Props> = props => {
  const progress = (props.currentRank + 1) / props.totalSteps

  if (!props.running) {
    return <Spinner value={0} size={SPINNER_SIZE} />
  }

  if (props.currentRank == null) return <Icon icon={IconNames.REFRESH} intent={Intent.WARNING} size={SPINNER_SIZE} />

  if (progress >= 1) return <Icon icon={IconNames.CONFIRM} intent={Intent.SUCCESS} size={SPINNER_SIZE} />

  return <Spinner value={progress * PROGRESS_DIVISOR} intent={Intent.SUCCESS} size={SPINNER_SIZE} />
}
